export default __webpack_public_path__ + "assets/question.6a5492f7.svg";